export default __webpack_public_path__ + "static/media/ReviewProfile.bd084ad6.png";